import { useCallback, useEffect, useRef } from 'react';

export function useBindCustomEvent(eventName, eventHandler, elemRef) {
    const newRef = useRef()
    if (!elemRef) {
        elemRef = newRef;
    }
    const callback = useCallback(eventHandler, [eventHandler]);
    useEffect(() => {
        const currentRef = elemRef.current;
        if (currentRef) {
            currentRef.addEventListener(eventName, callback);
            return () => {
                currentRef.removeEventListener(eventName, callback);
            };
        }
    }, [eventName, callback, elemRef]);

    return elemRef;
}
